import React from 'react';

import classNames from 'classnames';

/**
 * The dashed "add" button the conditional set-up pages lead with. As a toggle
 * it reports its state through aria-expanded; with as="a" it is a link out.
 *
 * A plain element rather than TextButton: its txt-button class sets the
 * case, weight and border, which outrank the dashed outline here.
 */
export default function GhostButton({ children, expanded, as, className, ...props }) {
    const Tag = as || 'button';

    return (
        <Tag
            type={Tag === 'button' ? 'button' : undefined}
            aria-expanded={Tag === 'button' ? !!expanded : undefined}
            className={classNames(
                className,
                'tw-inline-flex tw-items-center tw-rounded-lg tw-border-[1.5px] tw-border-dashed tw-bg-transparent tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-no-underline hover:tw-border-blue hover:tw-text-blue hover:tw-no-underline',
                expanded ? 'tw-border-blue tw-text-blue' : 'tw-border-charcoal-25 tw-text-charcoal-75',
            )}
            {...props}
        >
            {children}
        </Tag>
    );
}
